export default __webpack_public_path__ + "static/media/game-categories-section.6a52b2b4.svg";